import { Responsive } from './types';

/**
 * 类型守卫：检查是否为响应式对象
 */
function isResponsiveObject<T>(value: Responsive<T>): value is {
  base?: T;
  sm?: T;
  md?: T;
  lg?: T;
  xl?: T;
} {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * 将响应式值转换为 CSS 值
 * 目前简单实现，只返回第一个值
 * 后续可以扩展为支持媒体查询的响应式样式
 */
export function getResponsiveValue<T>(value: Responsive<T> | undefined): T | undefined {
    if (!value) return undefined;
  
    if (isResponsiveObject(value)) {
    // 如果是响应式对象，返回 base 值或第一个可用的值
        return value.base || value.sm || value.md || value.lg || value.xl;
    }
  
    return value;
}

/**
 * 构建响应式样式对象
 */
export function buildResponsiveStyles(props: {
  width?: Responsive<string | number>;
  height?: Responsive<string | number>;
  minWidth?: Responsive<string | number>;
  maxWidth?: Responsive<string | number>;
  minHeight?: Responsive<string | number>;
  maxHeight?: Responsive<string | number>;
  margin?: Responsive<string | number>;
  marginTop?: Responsive<string | number>;
  marginRight?: Responsive<string | number>;
  marginBottom?: Responsive<string | number>;
  marginLeft?: Responsive<string | number>;
  marginX?: Responsive<string | number>;
  marginY?: Responsive<string | number>;
}): React.CSSProperties {
    const styles: React.CSSProperties = {};
  
    if (props.width !== undefined) styles.width = getResponsiveValue(props.width);
    if (props.height !== undefined) styles.height = getResponsiveValue(props.height);
    if (props.minWidth !== undefined) styles.minWidth = getResponsiveValue(props.minWidth);
    if (props.maxWidth !== undefined) styles.maxWidth = getResponsiveValue(props.maxWidth);
    if (props.minHeight !== undefined) styles.minHeight = getResponsiveValue(props.minHeight);
    if (props.maxHeight !== undefined) styles.maxHeight = getResponsiveValue(props.maxHeight);
  
    if (props.margin !== undefined) styles.margin = getResponsiveValue(props.margin);
    if (props.marginTop !== undefined) styles.marginTop = getResponsiveValue(props.marginTop);
    if (props.marginRight !== undefined) styles.marginRight = getResponsiveValue(props.marginRight);
    if (props.marginBottom !== undefined) styles.marginBottom = getResponsiveValue(props.marginBottom);
    if (props.marginLeft !== undefined) styles.marginLeft = getResponsiveValue(props.marginLeft);
  
    // 处理 marginX 和 marginY
    if (props.marginX !== undefined) {
        const marginXValue = getResponsiveValue(props.marginX);
        if (marginXValue !== undefined) {
            styles.marginLeft = marginXValue;
            styles.marginRight = marginXValue;
        }
    }
  
    if (props.marginY !== undefined) {
        const marginYValue = getResponsiveValue(props.marginY);
        if (marginYValue !== undefined) {
            styles.marginTop = marginYValue;
            styles.marginBottom = marginYValue;
        }
    }
  
    return styles;
} 